// extracted by mini-css-extract-plugin
export default {"web_apps_block":"web-apps_web_apps_block__7JNrz","main_block":"web-apps_main_block__KKjOh"};